import { KemMessageControllerService } from "@ch/generated";
import type { TKemDefaultPayloadResponseData } from "./types";

const getKemChatPayload = async (): Promise<
  TKemDefaultPayloadResponseData | undefined
> => {
  try {
    const data =
      await KemMessageControllerService.kemMessageControllerGetKemPayload();
    return data as TKemDefaultPayloadResponseData;
  } catch {
    return undefined;
  }
};

export default getKemChatPayload;
